var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPtBrWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 18.6665C15.0851 18.6665 18.6669 15.0848 18.6669 10.6665C18.6669 6.24822 15.0851 2.6665 10.6668 2.6665C6.24842 2.6665 2.66663 6.24822 2.66663 10.6665C2.66663 15.0848 6.24842 18.6665 10.6668 18.6665Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 10.6665H18.6669",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7436 10.6665C13.5924 13.592 12.5149 16.3937 10.6667 18.6665C8.81843 16.3937 7.74086 13.592 7.58972 10.6665C7.74086 7.74099 8.81843 4.93931 10.6667 2.6665C12.5149 4.93931 13.5924 7.74099 13.7436 10.6665V10.6665Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_1726)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_383_1726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.02734 8.97803H27.0273V23.978H7.02734V8.97803Z",
    fill: "#009B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0273 9.82471L25.0156 16.4651L17.0273 23.101L9 16.4651L17.0273 9.82471Z",
    fill: "#FEDF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0273 20.0043C18.7585 20.0043 20.1618 18.4255 20.1618 16.478C20.1618 14.5304 18.7585 12.9517 17.0273 12.9517C15.2962 12.9517 13.8928 14.5304 13.8928 16.478C13.8928 18.4255 15.2962 20.0043 17.0273 20.0043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4445 16.2455C14.9025 16.2455 14.3762 16.3376 13.8811 16.5086C13.9045 18.4341 15.2963 19.9867 17.0117 19.9867C18.0721 19.9867 19.0117 19.3902 19.577 18.4823C18.6063 17.1227 17.1131 16.2455 15.4445 16.2455ZM20.0838 17.1358C20.1189 16.9165 20.1423 16.6929 20.1423 16.4604C20.1423 14.513 18.7388 12.9341 17.0078 12.9341C15.7174 12.9341 14.6101 13.8157 14.1267 15.0657C14.5517 14.9692 14.9883 14.9165 15.4367 14.9165C17.2612 14.9209 18.9064 15.7718 20.0838 17.1358Z",
    fill: "#002776"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_1726"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.77734,
    y: 9.77783,
    width: 14.0003,
    height: 14,
    rx: 6.99998,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_383_1726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    fill: "white",
    transform: "translate(7.02734 8.97803)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPtBrWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pt-br-white.cf7bf92f.svg";
export { ForwardRef as ReactComponent };